module.exports = __webpack_public_path__ + "static/media/naturalGas.00cd5ebe.png";